module.exports.getLanguagesFromValues = (items) => {
    function Capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function orderObjectByKeys (unordered) {
        const ordered = {};
        Object.keys(unordered).sort().forEach(function (key) {
            ordered[key] = unordered[key];
        });
        return ordered;
    }

    let languages = [];
    let terms = {};

    // terms.push();

    items.forEach((item) => {
        let langs = item.languages;
        if (langs && langs !== undefined) {
            let spliter = langs.split(',');
            if (spliter && spliter.length > 0) {
                spliter.forEach((term) => {
                    if (term && term !== undefined && term !== 'undefined' && term !== 'Undefined' && term !== null && term !== 'null' && term !== 'Null') {
                        term = term.toLowerCase();
                        if (!languages.includes(term) && term !== '' && term !== ' ') {
                            languages.push(term);
                            terms[term] = ({value: term, label: Capitalize(term)});
                        }
                    }
                });
            }
        }
    });

    let fTerms = [];
    fTerms.push({value:'', label:'All'});
    fTerms.push({value:'english', label:'English'});
    
    terms = orderObjectByKeys(terms);
    Object.keys(terms).forEach((key) => {
        if (terms[key].value !== 'english') {
            fTerms.push({value: terms[key].value, label: terms[key].label})
        }
    });

    return fTerms;
}